<carm-card class="carm-widget carm-summary-widget">
  <carm-card-title>
    <div class="row">
      <div
      class="col-md-12 inline-content"
      style="padding-right: 0"
      data-cy="commercial-accounting-homepage-title">
        <span>{{
          'dashboard.widgets.commercial_accounting.title' | translate
        }}</span>
        <carm-popover class="mrgn-lft-sm mrgn-tp-sm">
          {{ 'dashboard.widgets.commercial_accounting.tooltip' | translate }}
        </carm-popover>
      </div>
    </div>
  </carm-card-title>
  <carm-card-content>
    <div class="row">
      <div
      class="col-md-12 mrgn-tp-sm text-center font-1_3x"
      data-cy="CADs-due">
        <strong
          >{{
            'dashboard.widgets.commercial_accounting.descriptionPartOne'
              | translate
          }}
          {{ days }}
          {{
            'dashboard.widgets.commercial_accounting.descriptionPartTwo'
              | translate
          }}</strong
        >
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 mrgn-tp-md text-center font-2_5x">
        <strong *ngIf="!loading">{{ commericalAccounting }}</strong>
        <mat-progress-spinner
          *ngIf="loading"
          attr.aria-label="{{ 'application_features.loading' | translate }}"
          class="mat-spinner-color spinner-styling"
          mode="indeterminate"
          value="50"
        >
        </mat-progress-spinner>
      </div>
    </div>
    <div *ngIf="!loading" class="row">
      <div class="col-md-12 mrgn-tp-sm text-center">
        <em
          ><a
          [carmRouterLink]="viewAllCommericalAccountingUrl"
          data-cy="view-releases">{{
            'dashboard.widgets.commercial_accounting.view_all_requests'
              | translate
          }}</a></em
        >
      </div>
    </div>
  </carm-card-content>
</carm-card>
